import { formatNumber } from "./format-number"

export function formatMatic<T>(value: number | undefined | null, defaultValue: T): T | number {
  return formatNumber(value, 3, defaultValue)
}
